export const setDatePickers = (el) => {
  const currentYear = new Date().getFullYear();
  jQuery(`#${el.id}`)?.datepicker &&
    jQuery(`#${el.id}`)?.datepicker({
      showAnim: "slideDown",
      changeMonth: true,
      changeYear: true,
      yearRange: `1900:${currentYear}`,
      dateFormat: "mm/dd/yy",
      maxDate: 0,
      defaultDate: new Date(), // Ensures year dropdown always goes up to the current year
      onSelect: function () {
        el.setAttribute("value", el.value);
       // let dateSplit = el.value.split("/");
        // let dobReArranged = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
        hideValidationMessage(el);
        el.focus();

      },
    });
};

export const setMonthPickers = (el) => {
  const currentYear = new Date().getFullYear();
  jQuery(`#${el.id}`)?.datepicker &&
    jQuery(`#${el.id}`)?.datepicker({
      showAnim: "slideDown",
      changeMonth: true,
      changeYear: true,
      beforeShow: function(input, inst) {
        jQuery(inst.dpDiv).addClass('month-year-picker');
        },
      yearRange: `1900:${currentYear}`, // Consistent with setDatePickers, allows selection from 100 years ago to current year
      dateFormat: "mm/yy",
      onSelect: function () {
        el.setAttribute("value", el.value);
        let dateSplit = el.value.split("/");
        // let dobReArranged = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
        hideValidationMessage(el);
        el.focus();
      },
     
    });
};